module.exports = __webpack_public_path__ + "static/media/bodytype.378a29bf.svg";